<template>
  <div
    class="d-flex flex-column"
    style="gap: 16px;"
  >
    <us-bank-failures />
    <list-of-us-bank-failures />
  </div>
</template>
 <script>
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'
import ListOfUsBankFailures from '@/theme/default/views/banking/risk/liquidity/bank-failures/ListOfUsBankFailures.vue'
import UsBankFailures from '@/theme/default/views/banking/risk/liquidity/bank-failures/UsBankFailures.vue'

export default {
  name      : 'LiquidityRiskAssessment',
  components: {
    ListOfUsBankFailures,
    UsBankFailures

  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    data: 'RiskLiquidity.MonitoringLiquidity.Data'
  },
  data () {
    return {
      minBlockHeight: 350,
      switchValue   : true

    }
  },
  computed: {
    data () {
      return this.data || {}
    }

  },

  watch  : {},
  mounted () {},
  methods: {}
}
  </script>

  <style scoped>
  </style>
